<script setup>
import { computed } from 'vue'
import { Link } from '@inertiajs/vue3'
import { ChevronRight } from 'lucide-vue-next'
import TutorCard from '@/Components/TutorCard.vue'
import SnapRail from '@/Components/ui/SnapRail.vue'
// Aliased: the prop below is also called `tutors`, and in a template the prop
// wins — calling the array as a function kills the whole section silently.
import { tutors as tutorsRoute } from '@/routes/index'

/**
 * "Meet some of our tutors" — the section the concept leads with once the
 * universities have done their work, and the one the homepage was missing.
 *
 * The scrolling lives in SnapRail, shared with the subject rail below it, so
 * the two behave identically.
 */
const props = defineProps({
  tutors: { type: Array, default: () => [] },
})

const hasTutors = computed(() => props.tutors.length > 0)
</script>

<template>
  <section v-if="hasTutors" id="our-tutors" class="scroll-mt-24 pb-14 md:pb-20">
    <div class="container-page">
      <SnapRail label="tutors" :items="tutors">
        <template #heading>
          <div v-reveal>
            <h2 class="text-2xl md:text-3xl">Meet some of our tutors</h2>
            <p class="mt-2 text-[15px] text-muted">
              Every one interviewed, grade-verified and DBS checked before they teach.
            </p>
          </div>
        </template>

        <template #controls>
          <Link :href="tutorsRoute()" class="inline-flex items-center gap-1 text-sm font-semibold text-brand hover:underline">
            View all tutors <ChevronRight class="size-4" />
          </Link>
        </template>

        <template #item="{ item, index }">
          <div v-reveal="{ delay: Math.min(index, 4) * 70 }">
            <TutorCard :tutor="item" view-mode="grid" />
          </div>
        </template>
      </SnapRail>
    </div>
  </section>
</template>
